import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

/** Build counters and demo-project event stream — mirrors stacks-agents `src/app/api/analytics/`. */
@Injectable({ providedIn: 'root' })
export class AnalyticsApiService {
  constructor(private http: HttpClient) {}

  /** Builder JWT for the stacks-agents API. */
  private agentsAuthHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` })
  }

  getDemoAnalyticsEvents(
    projectId: string,
    opts: { event?: string; fromDate?: string; toDate?: string; limit?: number } = {},
  ): Promise<any[]> {
    // Built key by key: HttpParams stringifies an absent option into the literal
    // "undefined", which the backend would treat as a real filter value.
    let params = new HttpParams().set('projectId', String(projectId))
    Object.entries(opts).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params = params.set(key, String(value))
    })

    return this.http
      .get<{ data?: any[] }>(`${environment.agentsUrl}v4/retrieval/analytics/demo-events`, {
        headers: this.agentsAuthHeaders(),
        params,
      })
      .pipe(
        map(body => body?.data ?? []),
        catchError(() => of([])),
      )
      .toPromise() as Promise<any[]>
  }

  /** Increments the iOS/Android build counter in stacks_analytics. */
  async trackBuild(projectId: string, platform: 'ios' | 'android'): Promise<void> {
    await this.http
      .post(`${environment.agentsUrl}v4/creation/analytics/build`, { projectId, platform }, {
        headers: this.agentsAuthHeaders(),
      })
      .pipe(catchError(() => of(null)))
      .toPromise()
  }
}
